import { Link } from 'wouter'
import { useI18n } from '../i18n'
import { BrandMark } from './BrandMark'

export function Logo({ compact = false }: { compact?: boolean }) {
  const { t } = useI18n()
  return (
    <Link href="/" className="group inline-flex items-center gap-2.5" aria-label={t('logo.home')}>
      <span className="grid size-9 place-items-center overflow-hidden rounded-[12px] shadow-[0_5px_18px_rgba(21,24,23,.16)] transition-transform duration-300 group-hover:-rotate-3 group-hover:scale-105">
        <BrandMark className="size-9" />
      </span>
      {!compact && (
        <span className="text-[15px] font-semibold tracking-tight">
          Agent<span className="text-moss">—Me</span>
        </span>
      )}
    </Link>
  )
}
